export default "__VITE_ASSET__B70_eFt1__"